import { MailingAddressInput } from '@apollo/src/types';
import { Logger } from '@vue-storefront/core';

import getCustomerAccessToken from '../../helpers/internals/getCustomerAccessToken';
import { Context } from '../../types';
import { IUseUserAddressesRefs } from '../types';

const updateUserAddress =
  (context: Context, refs: IUseUserAddressesRefs) =>
  async (addressId: string, addressInput: MailingAddressInput) => {
    const customerAccessToken = getCustomerAccessToken(context);

    Logger.debug('useUserAddresses/updateUserAddress');

    try {
      refs.loading.value.updateUserAddress = true;

      const response = await context.$shopify.api.updateAddress({
        customerAccessToken,
        id: addressId,
        address: addressInput,
      });

      const data = response.data?.customerAddressUpdate;

      if (data && !data.customerUserErrors.length && !response.errors) {
        refs.result.value.updateUserAddress = true;
      } else {
        const errors = data?.customerUserErrors || response.errors;

        if (errors) {
          refs.error.value.updateUserAddress = errors;

          Logger.error('useUserAddresses/updateUserAddress/error', errors);
        }
      }
    } catch (error) {
      refs.error.value.updateUserAddress = error as Error;
      Logger.error('useUserAddresses/updateUserAddress/error', error);
    } finally {
      refs.loading.value.updateUserAddress = false;
    }
  };

export default updateUserAddress;
